module.exports = __webpack_public_path__ + "img/no-notifications.a4ca66da.svg";